export var Role;
(function (Role) {
    Role["ACCOUNT_SUPER_USER"] = "Account Super User";
    Role["APP_ADMIN"] = "App Admin";
    // INSTANCE_ADMIN = "Instance Admin",
})(Role || (Role = {}));
// settings
// export const EXPIRATION_CHECK_INTERVAL = 120000; // milliseconds
// export const TIME_BEFORE_EXPIRATION = 180000; // milliseconds
// export const NUMBER_OF_RETRY_FOR_JWT = 5;
// export const MAX_NUMBER_OF_TENANTS_PER_APP: Map<AppType, number> = new Map([
//     ["logging_service", 30],
//     ["directory_sync", 30],
// ]);
